function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.15 6.09124L4.64996 22.7512C4.56356 22.9205 4.52247 23.1092 4.53069 23.299C4.53891 23.4888 4.59616 23.6733 4.69687 23.8344C4.79757 23.9955 4.93829 24.1278 5.10532 24.2184C5.27235 24.309 5.45999 24.3547 5.64996 24.3512H26.1C26.3251 24.3522 26.5466 24.2951 26.7432 24.1855C26.9399 24.0759 27.1049 23.9175 27.2225 23.7255C27.3401 23.5336 27.4062 23.3146 27.4146 23.0896C27.4229 22.8646 27.3731 22.6413 27.27 22.4412L16.86 6.09124C16.7708 5.94429 16.6453 5.82279 16.4956 5.73848C16.3458 5.65416 16.1768 5.60986 16.005 5.60986C15.8331 5.60986 15.6641 5.65416 15.5144 5.73848C15.3646 5.82279 15.2391 5.94429 15.15 6.09124Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 12.2363V18.2363M16 21V20.92",
  className: "stroke",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.75 20.75C16.75 21.1642 16.4142 21.5 16 21.5C15.5858 21.5 15.25 21.1642 15.25 20.75C15.25 20.3358 15.5858 20 16 20C16.4142 20 16.75 20.3358 16.75 20.75Z",
  className: "fill",
  fill: "white"
});

function SvgWarningFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFill);
export default __webpack_public_path__ + "static/media/warning-fill.d5568d1d.svg";
export { ForwardRef as ReactComponent };